import type {
  WakeLoopEnvPreset,
  WakeLoopPathResolutionInput,
} from "../../config/paths";
import { resolveWakeLoopEnvPreset } from "../../config/paths";

export type DaemonServiceIdentity = {
  envPreset: WakeLoopEnvPreset;
  serviceName: string;
  launchdLabel: string;
  windowsServiceName: string;
  windowsDisplayName: string;
  cliEntryAliases: readonly string[];
};

const DAEMON_SERVICE_IDENTITY_BY_PRESET = {
  prod: {
    envPreset: "prod",
    serviceName: "wakeloop-daemon",
    launchdLabel: "com.wakeloop.wakeloop-background-service",
    windowsServiceName: "WakeLoop-Daemon",
    windowsDisplayName: "WakeLoop Daemon Service",
    cliEntryAliases: ["wakeloop"],
  },
  "dev-local": {
    envPreset: "dev-local",
    serviceName: "wakeloop-daemon-dev-local",
    launchdLabel: "com.wakeloop.wakeloop-background-service.dev-local",
    windowsServiceName: "WakeLoop-Daemon-DevLocal",
    windowsDisplayName: "WakeLoop Daemon Service (Dev Local)",
    cliEntryAliases: ["wakeloop-dev"],
  },
  canary: {
    envPreset: "canary",
    serviceName: "wakeloop-daemon-canary",
    launchdLabel: "com.wakeloop.wakeloop-background-service.canary",
    windowsServiceName: "WakeLoop-Daemon-Canary",
    windowsDisplayName: "WakeLoop Daemon Service (Canary)",
    cliEntryAliases: ["wakeloop-canary"],
  },
} as const satisfies Record<WakeLoopEnvPreset, DaemonServiceIdentity>;

export function resolveDaemonServiceIdentity(
  input: WakeLoopPathResolutionInput = {}
): DaemonServiceIdentity {
  const preset = resolveWakeLoopEnvPreset(input);
  return DAEMON_SERVICE_IDENTITY_BY_PRESET[preset];
}
